import REDUX_LOCAL_KEYS from 'modules/redux/constants/local-keys'

function getLocalKeysReduxUtil (instance) {
  return REDUX_LOCAL_KEYS[instance.className] || []
}

export default getLocalKeysReduxUtil
